import ShipmentStore from './ShipmentStore';
import UserStore from './UserStore';
import api from './api';
import { dataorchApi } from './api';
import DriverStore from './Driver';
import ClientStore from './Client';
import DeliveryStore from './Delivery';
import JobStore from "./Job";
import ShipmentSearchStore from './ShipmentSearchStore';
import UsersManager from "./UsersManager";
import ReportStore from './ReportStore';
import ReportFormStore from './ReportFormStore';
import InsuranceStore from "./InsuranceStore";
import ClaimsListStore from "./ClaimsListStore";

const driverStore = new DriverStore(api);
const deliveryStore = new DeliveryStore(api, dataorchApi);

export const stores = {
  deliveryStore,
  shipmentStore: new ShipmentStore(),
  userStore: new UserStore(),
  clientStore: new ClientStore(api),
  jobStore: new JobStore(api),
  shipmentSearchStore: new ShipmentSearchStore(),
  usersManager: new UsersManager(api),
  reportStore: new ReportStore(api),
  reportFormStore : new ReportFormStore(api),
  insuranceStore: new InsuranceStore(api),
  claimsListStore: new ClaimsListStore(api)
};
